import { useCallback } from 'react';

import { addShipFrom, editShipFrom } from '../services/api';

import type { CreateShipFromPayload, ShipFrom, UpdateShipFromPayload } from '@shipstation/client-common/types/ship-from';

/** Shared request pairing for creating/updating a ship-from location. Dispatching the result to the seller store is left to callers so they can enrich it first. */
export const useShipFromRequest = () => {
  const createShipFrom = useCallback(async (payload: CreateShipFromPayload, shouldCreateInventorySource = false): Promise<ShipFrom> => {
    return addShipFrom(payload, shouldCreateInventorySource);
  }, []);

  const updateShipFrom = useCallback(async (payload: UpdateShipFromPayload): Promise<ShipFrom> => {
    return editShipFrom(payload);
  }, []);

  return { createShipFrom, updateShipFrom };
};
